import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function EstimatedReadyCard({ estimatedReady }) {
  const { t } = useTranslation();

  if (!estimatedReady) return null;

  const date = new Date(estimatedReady);

  const formatTime = (d) => {
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const formatDate = (d) => {
    return d.toLocaleDateString('fi-FI', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      <Box
        sx={{
          width: '48px',
          height: '48px',
          backgroundColor: '#fef3c7',
          borderRadius: theme.radius.lg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#f59e0b',
        }}
      >
        <AccessTimeIcon sx={{ fontSize: 24 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '13px', color: theme.colors.textMuted }}>
          {t('public_maintenance.estimated_ready')}
        </Typography>
        <Typography sx={{ fontSize: '20px', fontWeight: '700', color: theme.colors.text }}>
          {formatTime(date)}
        </Typography>
        <Typography sx={{ fontSize: '12px', color: theme.colors.textMuted }}>
          {formatDate(date)}
        </Typography>
      </Box>
    </Paper>
  );
}

export default EstimatedReadyCard;
